<template>
	<div id="Main">
		<div class="htitle">
			<p class="p">仅能查询近两年的数据</p>
		</div>
		<div class="box" @click="href(item)" v-for="(item,index) in list" :key="index">
			<p class="name">{{item.bussinessTypeName}}</p>
			<div class="content">
				<div class="item">
					<p class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/name.png')" />股东姓名</p>
					<p class="data">{{item.shareholdeName}}</p>
				</div>
				<div class="item">
					<p class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/mycode.png')" />股东代码</p>
					<p class="data">{{item.shareholdeCode}}</p>
				</div>
			</div>
			<van-row type="flex" justify="space-between" class="time">
				<van-col class="screen">申请时间：{{item.applyDate}}</van-col>
				<van-col class="">
					<van-icon class="icon" :name="require('../../assets/images/service/move.png')" />
				</van-col>
			</van-row>
		</div>
		<div v-if="list.length==0">{{tisp}}</div>
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {},
		data() {
			return {
				type: '',
				/*  1红利领取 2股权过出 3股权过入 4股权质押 5股权解除质押 */
				user: '',
				/* 股东账号 */
				shareholderCode: '',
				/* 股东账号 */
				list: [],
				tisp: '数据加载中...',
				loginif:false
			}
		},
		methods: {
			href(item) {
				if(!this.loginif){
					this.$router.push({
						path: "/register",
						query: {
							openId: this.openId
						}
					})
				}
				this.$router.push({
					path: '/mydetails',
					query: {
						id: item.id
					}
				})
			},
			getdata() { /* 获取申请列表 */
				// axiosPost.listData({shareholdeCode: this.user,bussinessType:this.type}).then((res) => {
				axiosPost.listData({
					shareholdeCode: this.shareholderCode
				}).then((res) => {
					window.console.log(res.data.data)
					if (res.data.code == 200) {
						this.list = res.data.data.list;
					} else {
						this.$toast({
							duration: 4000,
							message: res.data.msg
						});
					}
					this.tisp = "暂无申请记录"
					// if(this.type==1){
					// 	this.tisp="暂无红利领取业务"
					// }else if(this.type==2){
					// 	this.tisp="暂无股权过出业务"
					// }else if(this.type==3){
					// 	this.tisp="暂无股权过入业务"
					// }else if(this.type==4){
					// 	this.tisp="暂无股权质押业务"
					// }else if(this.type==5){
					// 	this.tisp="暂无股权解除质押业务"
					// }
				}).catch((res) => {
					window.console.log(res)
				})
			},
			getShare() {
				this.$toast.loading({
					message: '数据加载中...',
					forbidClick: true,
					duration: 0
				});
				axiosPost.getRealNameBindByOpenId({
					openId: this.openId
				}).then((res) => { /* 验证是否实名 */
					this.$toast.clear();
					window.console.log(res.data)
					if(res.data.data&& res.data.data.shareholderCode){
						this.loginif=true;
						if (res.data.code == 200) {
							if (res.data.data && res.data.data.authenticationStatus && res.data.data.authenticationStatus == 1) {
								this.shareholderCode = res.data.data.shareholderCode
								this.getdata();
							} else {
								this.tisp = "实名认证通过后才能查询业务"
								this.popup()
								// this.$toast({
								// 	duration: 4000,
								// 	message: '实名认证通过后才能查询业务！'
								// });
								this.disabled = false
							}
						} else {
							this.popup()
							this.tisp = "实名认证通过后才能查询业务"
							// this.$toast({
							// 	duration: 4000,
							// 	message: '实名认证通过后才能查询业务！'
							// });
							this.disabled = false
						}
					}
					else{
						this.loginif=false;
						this.$router.push({
							path: "/register",
							query: {
								openId: this.openId
							}
						})
					}
					
				}).catch((res) => {
					window.console.log(res)
				})
			},
			popup() {
				if(this.loginif==true){
					this.$dialog.confirm({
						title: '提示',
						message: '您尚未实名认证，是否前往认证？'
					}).then(() => {
						this.$router.push({
							path: '/attestationlogin',
							query:{
								openId:this.openId,
							}
						})
					}).catch(() => {
						
					});
				}
	
			}
		},
		mounted() {
			// this.type = this.$route.query.type
			// this.user = this.$route.query.user
			this.openId = this.$route.query.openId;
			this.getShare();
		},
	}
</script>

<style lang="scss" scoped>
	.htitle {
		padding: 1rem 0;
		text-align: left;

		.p {
			color: #999999;
			font-size: 1.6rem;
			margin-top: 0.5rem;
		}
	}

	#Main {
		padding: 1.3rem;
		min-height: 100vh;
		background-color: #f2f9ff;

		.box {
			background-color: #fff;
			border-radius: 8px;
			padding: 0 1rem;
			margin-bottom: 2rem;
			box-shadow: 0 2px 5px 1px #e4ebfa;

			.time {
				font-size: 1.4rem;
				color: #999999;
				line-height: 3.5rem;

				.icon {
					font-size: 2rem;
					line-height: 3.5rem;
				}
			}

			.name {
				text-align: left;
				font-size: 1.8rem;
				color: #333;
				line-height: 3.5rem;
				padding-top: 0.6rem;
				font-weight: bold;
			}

			.content {
				display: flex;
				flex-wrap: wrap;

				.item {
					width: 50%;
					padding: 1rem 0;
					border-top: 1px solid #e0dfdf;
					border-bottom: 1px solid #e0dfdf;
					font-size: 0;
					line-height: 2rem;

					&:nth-child(2n) {
						border-left: 1px solid #e0dfdf;
					}

					.title {
						font-size: 1.5rem;
						color: #8c8b8b;

						.icon {
							margin-right: 0.5rem;
							vertical-align: middle;
						}
					}

					.data {
						color: #333333;
						font-size: 1.6rem;
					}
				}
			}
		}
	}
</style>
